import { Translations } from '@domain/admission';

export interface EditFieldModalLabels {
  title?: string;
  saveButton?: string;
  cancelButton?: string;
}

export interface ValidationRules {
  required?: boolean;
  pattern?: {
    value: RegExp;
    message: string;
  };
  validate?: (value: string, language: string, allValues: Translations) => boolean | string;
}

export interface EditFieldModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: Translations) => void;
  defaultValue?: Translations;
  isEditDisabled?: boolean;
  labels?: EditFieldModalLabels;
  maxLength?: number;
  placeholder?: string;
  validation?: ValidationRules;
  helperText?: string;
  inputLabel?: string;
  disableButtonWithEmptyField?: boolean;
  subtitle?: string;
}

export interface Form {
  name: Translations;
  nameLanguage: string;
}

export const OFFER_NAME_MAX_LENGTH = 100;
